import { defineComponent as _defineComponent } from 'vue'
import { computed, onUnmounted, ref, watch } from "vue";
import { api } from "@/main";
import Card from "@/components/Card.vue";
import DynamicForm from "@/components/DynamicForm.vue";
import ButtonWithConfirmation from "@/components/ButtonWithConfirmation.vue";
import { Subscription } from "@/api";

interface AIPrincipalToken {
  id: string;
  version: number;
  aiPrincipalId: string;
  name: string;
  lastUsedTimestamp: string | null;
  createdTimestamp: string;
  deletedTimestamp: string | null;
}

interface AIPrincipalTokenSecret {
  aiPrincipalToken: AIPrincipalToken;
  rawToken: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AIPrincipalTokens',
  props: ["aiId"],
  setup(__props) {

const props = __props



const tokenSubscription = ref<Subscription | null>(null);
const tokens = ref<AIPrincipalToken[]>([]);
const showCreateDialog = ref(false);
const createdToken = ref<AIPrincipalTokenSecret | null>(null);
const showCreatedTokenDialog = ref(false);

const createActions = computed(() => [
  {
    icon: "mdi-plus",
    click: () => {
      showCreateDialog.value = true;
    },
    color: "primary",
  },
]);

function resubscribe(aiId: string) {
  if (tokenSubscription.value != null) {
    api.unsubscribe(tokenSubscription.value);
    tokenSubscription.value = null;
  }

  tokens.value = [];
  tokenSubscription.value = api.subscribe("AIPrincipalToken", "parent:" + aiId, (token: AIPrincipalToken) => {
    const index = tokens.value.findIndex(existingToken => existingToken.id === token.id);
    if (token.deletedTimestamp) {
      if (index >= 0)
        tokens.value.splice(index, 1);
      return;
    }

    if (index >= 0)
      tokens.value.splice(index, 1, token);
    else
      tokens.value.push(token);
  });
}

function createToken(form: { name: string }): Promise<AIPrincipalTokenSecret> {
  return api.rpc("ai", "createAIPrincipalToken", {
    aiPrincipalId: props.aiId,
    name: form.name,
  });
}

function handleCreateSuccess(response: AIPrincipalTokenSecret) {
  createdToken.value = response;
  showCreateDialog.value = false;
  showCreatedTokenDialog.value = true;
}

function revokeToken(token: AIPrincipalToken): Promise<void> {
  return api.rpc("ai", "revokeAIPrincipalToken", {
    aiPrincipalId: props.aiId,
    tokenId: token.id,
  });
}

function copyToken() {
  if (!createdToken.value)
    return;

  if (!navigator.clipboard) {
    api.emitError("Clipboard access is not available in this browser");
    return;
  }

  navigator.clipboard.writeText(createdToken.value.rawToken).catch(() => {
    api.emitError("Could not copy token to clipboard");
  });
}

function formatTimestamp(timestamp: string | null): string {
  if (!timestamp)
    return "Never";

  return new Date(timestamp).toLocaleString();
}

watch(() => props.aiId, (aiId) => {
  if (aiId)
    resubscribe(aiId);
}, { immediate: true });

onUnmounted(() => {
  if (tokenSubscription.value != null)
    api.unsubscribe(tokenSubscription.value);
});

return { __sfc: true,props, tokenSubscription, tokens, showCreateDialog, createdToken, showCreatedTokenDialog, createActions, resubscribe, createToken, handleCreateSuccess, revokeToken, copyToken, formatTimestamp, Card, DynamicForm, ButtonWithConfirmation }
}

})